import { render, staticRenderFns } from "./TechBlurb.vue?vue&type=template&id=e0ad0a5c&scoped=true&"
import script from "./TechBlurb.vue?vue&type=script&lang=js&"
export * from "./TechBlurb.vue?vue&type=script&lang=js&"
import style0 from "./TechBlurb.vue?vue&type=style&index=0&id=e0ad0a5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ad0a5c",
  null
  
)

export default component.exports